module.exports = require('../_components/@alicd/next-time-picker/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/time-picker/index.js
// module id = 111
// module chunks = 0